export default function Streetview({ lat, lon }: { lat: number; lon: number }) {
  const key = "AIzaSyAMAsDnJngyooMljEtBxBbMJqYfH0C8Gic";
  const url = `https://www.google.com/maps/embed/v1/streetview?key=${key}&location=${lat},${lon}`;
  console.log(lat, lon);
  return <iframe id="streetview" src={url}></iframe>;
}
